import { getLocale } from '../../utils/pathHelper';

type translationKeys =
'search'|
'yadoSearchPlaceholder'|
'yadoSearchFormAlert'|
'yadoListTitle'|
'yadoListTitleFor'|
'checkIn'|
'checkOut'|
'numberOfGuests'|
'guestCount'|
'guestAndNightCount'|
'roomCount'|
'otherResortCount'|
'countResortItems'|
'countResorts'|
'twelveAndUnder'|
'searchTitle'|
'seeMore'|
'recommended'|
'adults'|
'children'|
'student' |
'senior' |
'childAges'|
'lift'|
'rental'|
'hotel'|
'lesson'|
'transport'|
'insurance'|
'allResorts'|
'seeItemsForThisResort'|
'compareResorts'|
'otherResorts'|
'notFoundResorts'|
'seeMap'|
'lowestPrice'|
'minutes'|
'withinMinutes'|
'yado'|
'resort'|
'prefecture'|
'area'|
'adjacent'|
'walk'|
'shuttle_bus'|
'checkPrice'|
'soldOut'|
'noRoomsAvailableForTheSelectedDate'
;

export type TranslationLocales = 'en'|'ja'|'zh-CN'|'zh-HK'|'zh-TW';

type ITranslationFunction = {
  [key in translationKeys]: ({}?: { [arg: string]: string|number }) => string;
}

const locale: string = getLocale() || 'en';

const translation: {
  [locale in TranslationLocales]: ITranslationFunction
} = {
  'en': {
    search: () => 'Search',
    yadoSearchPlaceholder: () => 'Hotel / Ski Resort / Area',
    yadoSearchFormAlert: () => 'Please select destination and number of guests.',
    yadoListTitle: () => 'Hotels',
    yadoListTitleFor: ({ subject, count }: { subject: string, count: number }) => `${count} ${count === 1 ? 'Hotel' : 'Hotels'} for ${subject}`,
    checkIn: () => 'Check-In',
    checkOut: () => 'Check-Out',
    numberOfGuests: () => 'No. of Guests',
    guestCount: ({ adults, children }: { adults: number, children: number }) => `${adults} ${adults === 1 ? 'Adult' : 'Adults'}・${children} ${children === 1 ? 'Child' : 'Children'}`,
    guestAndNightCount: ({ guests, nights }: { guests: number, nights: number }) => `${guests} ${guests === 1 ? 'guest' : 'guests'} ${nights} ${nights === 1 ? 'night' : 'nights'}`,
    roomCount: ({ count }: { count: number }) => `${count} ${count === 1 ? 'room' : 'rooms'}`,
    otherResortCount: ({ count }: { count: number }) => `${count} ${count === 1 ? 'resort' : 'resorts'}`,
    countResortItems: ({ count }: { count: number }) => `${count} ${count === 1 ? 'item' : 'items'}`,
    countResorts: ({ count }: { count: number }) => `${count} ${count === 1 ? 'product' : 'products'}`,
    twelveAndUnder: () => `12 and Under`,
    searchTitle: ({ key }: { key: string }) => {
      let title = 'Search';
      if (key === 'yado') { title = 'Search Hotels'; }
      if (key === 'item') { title = 'Search Lift passes and others'; }
      return title;
    },
    seeMore: () => 'See More',
    recommended: () => 'Recommended',
    adults: () => 'Adults',
    children: () => 'Children',
    student: () => 'Student',
    senior: () => 'Senior',
    childAges: () => 'Child\'s age (years)',
    lift: () => 'Lift Pass',
    rental: () => 'Rental',
    hotel: () => 'Hotels',
    lesson: () => 'Lesson',
    transport: () => 'Transport',
    insurance: () => 'Insurance',
    allResorts: () => 'All Resorts',
    seeItemsForThisResort: () => 'See Tickets',
    compareResorts: () => 'Compare Resorts',
    otherResorts: () => 'Other Resorts',
    notFoundResorts: () => 'No Related Ski Resorts Found',
    seeMap: () => 'See Map',
    lowestPrice: () => 'Lowest Price',
    minutes: ({ minutes }: { minutes: number }) => `${minutes} ${minutes === 1 ? 'minute' : 'minutes'}`,
    withinMinutes: ({ minutes }: { minutes: number }) => `Within ${minutes} ${minutes === 1 ? 'minute' : 'minutes'}`,
    yado: () => 'Hotel',
    resort: () => 'Resort',
    prefecture: () => 'Prefecture',
    area: () => 'Area',
    adjacent: () => 'Ski In/Out',
    walk: () => 'walk',
    shuttle_bus: () => 'shuttle bus',
    checkPrice: () => 'Check Price',
    soldOut: () => 'Sold Out',
    noRoomsAvailableForTheSelectedDate: () => 'No rooms available for the selected date',
  },
  'ja': {
    search: () => '検索する',
    yadoSearchPlaceholder: () => 'ホテル・スキー場・エリア',
    yadoSearchFormAlert: () => '行き先と人数を選択してください。',
    yadoListTitle: () => 'ホテル一覧',
    yadoListTitleFor: ({ subject, count }: { subject: string, count: number }) => `${subject}のホテル ${count} 件`,
    checkIn: () => 'チェックイン',
    checkOut: () => 'チェックアウト',
    numberOfGuests: () => '人数',
    guestCount: ({ adults, children }: { adults: number, children: number }) => `大人 ${adults}・子ども ${children}`,
    guestAndNightCount: ({ guests, nights }: { guests: number, nights: number }) => `${guests} 人 ${nights} 晩`,
    roomCount: ({ count }: { count: number }) => `${count} 部屋`,
    otherResortCount: ({ count }: { count: number }) => `その他 ${count} 件のスキー場`,
    countResortItems: ({ count }: { count: number }) => `${count} item${count === 1 ? '' : 's'}`,
    countResorts: ({ count }: { count: number }) => `${count} スキー場`,
    twelveAndUnder: () => `12歳以下`,
    searchTitle: ({ key }: { key: string }) => {
      let title = 'Search';
      if (key === 'yado') { title = 'ホテルを検索'; }
      if (key === 'item') { title = 'リフト券検索'; }
      return title;
    },
    seeMore: () => 'もっと見る',
    recommended: () => 'おすすめ',
    adults: () => '大人',
    children: () => '子ども',
    student: () => '学生',
    senior: () => 'シニア',
    childAges: () => '子どもの年齢',
    lift: () => 'リフト券',
    rental: () => 'レンタル',
    hotel: () => 'ホテル',
    lesson: () => 'レッスン',
    transport: () => '交通',
    insurance: () => '保険',
    allResorts: () => 'すべてのスキー場',
    seeItemsForThisResort: () => 'このスキー場の商品を見る',
    compareResorts: () => 'スキー場を比較する',
    otherResorts: () => 'その他のスキー場',
    notFoundResorts: () => '関連したスキー場はありません',
    seeMap: () => '地図を見る',
    lowestPrice: () => '最低価格',
    minutes: ({ minutes }: { minutes: number }) => `${minutes} 分`,
    withinMinutes: ({ minutes }: { minutes: number }) => `${minutes} 分以内`,
    yado: () => 'ホテル',
    resort: () => 'スキー場',
    prefecture: () => '都道府県',
    area: () => 'エリア',
    adjacent: () => 'スキーイン・アウトできる',
    walk: () => '徒歩',
    shuttle_bus: () => 'シャトルバス',
    checkPrice: () => '価格を見る',
    soldOut: () => '売り切れ',
    noRoomsAvailableForTheSelectedDate: () => '選択した日程は満室です',
  },
  'zh-CN': {
    search: () => '搜索',
    yadoSearchPlaceholder: () => '酒店‧滑雪场‧地区',
    yadoSearchFormAlert: () => '请选择目的地和人数。',
    yadoListTitle: () => '酒店',
    yadoListTitleFor: ({ subject, count }: { subject: string, count: number }) => `${subject}的酒店 ${count}家`,
    checkIn: () => '入住',
    checkOut: () => '退房',
    numberOfGuests: () => '人数',
    guestCount: ({ adults, children }: { adults: number, children: number }) => `成人 ${adults}・儿童 ${children}`,
    guestAndNightCount: ({ guests, nights }: { guests: number, nights: number }) => `${guests}人 ${nights}晩`,
    roomCount: ({ count }: { count: number }) => `${count} 客房`,
    otherResortCount: ({ count }: { count: number }) => `其他 ${count} 个滑雪场`,
    countResortItems: ({ count }: { count: number }) => `${count} 件`,
    countResorts: ({ count }: { count: number }) => `${count} 商品`,
    twelveAndUnder: () => `12岁以下`,
    searchTitle: ({ key }: { key: string }) => {
      let title = '搜寻';
      if (key === 'yado') { title = '寻找酒店'; }
      if (key === 'item') { title = '查詢纜車券等'; }
      return title;
    },
    seeMore: () => '查看更多',
    recommended: () => '推荐',
    adults: () => '成人',
    children: () => '儿童',
    student: () => '学生',
    senior: () => '老年人',
    childAges: () => '儿童的年龄',
    lift: () => '缆车票',
    rental: () => '雪具租借',
    hotel: () => '酒店',
    lesson: () => '课程',
    transport: () => '交通',
    insurance: () => '保险',
    allResorts: () => '所有滑雪场',
    seeItemsForThisResort: () => '查看商品',
    compareResorts: () => '比较滑雪场',
    otherResorts: () => '其他滑雪场',
    notFoundResorts: () => '没有相关联的滑雪场',
    seeMap: () => '查看地图',
    lowestPrice: () => '最低价格',
    minutes: ({ minutes }: { minutes: number }) => `${minutes} 分钟`,
    withinMinutes: ({ minutes }: { minutes: number }) => `${minutes} 分钟以内`,
    yado: () => '酒店',
    resort: () => '滑雪场',
    prefecture: () => '都道府县',
    area: () => '地区',
    adjacent: () => '雪场区域内',
    walk: () => '步行',
    shuttle_bus: () => '接驳巴士',
    checkPrice: () => '查看价格',
    soldOut: () => '售尽',
    noRoomsAvailableForTheSelectedDate: () => '所选日期已客满',
  },
  'zh-HK': {
    search: () => '搜尋',
    yadoSearchPlaceholder: () => '酒店‧滑雪場‧地區',
    yadoSearchFormAlert: () => '請選擇目的地和人數。',
    yadoListTitle: () => '酒店一覽',
    yadoListTitleFor: ({ subject, count }: { subject: string, count: number }) => `${subject}的酒店 ${count} 間`,
    checkIn: () => '入住',
    checkOut: () => '退房',
    numberOfGuests: () => '人數',
    guestCount: ({ adults, children }: { adults: number, children: number }) => `大人 ${adults}・小童 ${children}`,
    guestAndNightCount: ({ guests, nights }: { guests: number, nights: number }) => `${guests} 人 ${nights} 晚`,
    roomCount: ({ count }: { count: number }) => `${count} 客房`,
    otherResortCount: ({ count }: { count: number }) => `其他${count}件滑雪場`,
    countResortItems: ({ count }: { count: number }) => `${count} 件`,
    countResorts: ({ count }: { count: number }) => `${count} 商品`,
    twelveAndUnder: () => `12歲或以下`,
    searchTitle: ({ key }: { key: string }) => {
      let title = '搜尋';
      if (key === 'yado') { title = '搜尋滑雪場'; }
      if (key === 'item') { title = '搜尋纜車票等'; }
      return title;
    },
    seeMore: () => '查看更多',
    recommended: () => '推介',
    adults: () => '成人',
    children: () => '小童',
    student: () => '學生',
    senior: () => '長者',
    childAges: () => '小童的年齡',
    lift: () => '纜車票',
    rental: () => '租借',
    hotel: () => '酒店',
    lesson: () => '課程',
    transport: () => '交通',
    insurance: () => '保險',
    allResorts: () => '所有滑雪場',
    seeItemsForThisResort: () => '查看產品',
    compareResorts: () => '比較滑雪場',
    otherResorts: () => '其他滑雪場',
    notFoundResorts: () => '沒有關聯的滑雪場',
    seeMap: () => '查看地圖',
    lowestPrice: () => '最低價格',
    minutes: ({ minutes }: { minutes: number }) => `${minutes} 分鐘`,
    withinMinutes: ({ minutes }: { minutes: number }) => `${minutes} 分鐘以內`,
    yado: () => '酒店',
    resort: () => '滑雪場',
    prefecture: () => '都道府縣',
    area: () => '地區',
    adjacent: () => '滑雪場內',
    walk: () => '步行',
    shuttle_bus: () => '接駁巴士',
    checkPrice: () => '查看價錢',
    soldOut: () => '售罄',
    noRoomsAvailableForTheSelectedDate: () => '所選的日子已客滿',
  },
  'zh-TW': {
    search: () => '搜尋',
    yadoSearchPlaceholder: () => '飯店・滑雪場・地區',
    yadoSearchFormAlert: () => '請選擇目的地和人數',
    yadoListTitle: () => '飯店',
    yadoListTitleFor: ({ subject, count }: { subject: string, count: number }) => `${subject}的飯店 ${count} 間`,
    checkIn: () => '入住',
    checkOut: () => '退房',
    numberOfGuests: () => '人數',
    guestCount: ({ adults, children }: { adults: number, children: number }) => `成人 ${adults}・兒童 ${children}`,
    guestAndNightCount: ({ guests, nights }: { guests: number, nights: number }) => `${guests}人${nights}晚`,
    roomCount: ({ count }: { count: number }) => `${count} 客房`,
    otherResortCount: ({ count }: { count: number }) => `其他${count}件滑雪場`,
    countResortItems: ({ count }: { count: number }) => `${count}件`,
    countResorts: ({ count }: { count: number }) => `${count} 商品`,
    twelveAndUnder: () => `12歲以下`,
    searchTitle: ({ key }: { key: string }) => {
      let title = '搜尋';
      if (key === 'yado') { title = '搜尋飯店'; }
      if (key === 'item') { title = '搜尋商品'; }
      return title;
    },
    seeMore: () => '查看更多',
    recommended: () => '推薦',
    adults: () => '成人',
    children: () => '兒童',
    student: () => '學生',
    senior: () => '年長者',
    childAges: () => '兒童的年齡',
    lift: () => '纜車券',
    rental: () => '租借',
    hotel: () => '飯店',
    lesson: () => '課程',
    transport: () => '交通',
    insurance: () => '保險',
    allResorts: () => '所有滑雪場',
    seeItemsForThisResort: () => '查看產品',
    compareResorts: () => '比較滑雪場',
    otherResorts: () => '其他滑雪場',
    notFoundResorts: () => '沒有關聯的滑雪場',
    seeMap: () => '查看地圖',
    lowestPrice: () => '最低價格',
    minutes: ({ minutes }: { minutes: number }) => `${minutes}分鐘`,
    withinMinutes: ({ minutes }: { minutes: number }) => `${minutes} 分鐘以內`,
    yado: () => '飯店',
    resort: () => '滑雪場',
    prefecture: () => '都道府縣',
    area: () => '地區',
    adjacent: () => '雪場區域內',
    walk: () => '步行',
    shuttle_bus: () => '接駁巴士',
    checkPrice: () => '查看價格',
    soldOut: () => '售罄',
    noRoomsAvailableForTheSelectedDate: () => '所選的日子已客滿',
  },
};

export default translation[locale];
